import routes from "../../config/routes";
export function getFirstAccessibleRoute(remainingRoutesParam, configPerm) {
    const remainingRoutes = [...remainingRoutesParam]; // This is needed after the second log out / log in because the reference remains the same (with deleted routes because of the shift array method)
    while (remainingRoutes.length > 0) {
        const route = remainingRoutes.shift();
        if (route === undefined ||
            route.path === undefined ||
            route.authority === false ||
            (route.hideInMenu && route.path !== "/fallback")) {
            continue;
        }
        if (Array.isArray(route.routes)) {
            const shouldDeepIn = typeof route.authority === "undefined" ||
                (typeof route.authority === "boolean" && route.authority) ||
                (Array.isArray(route.authority) && route.authority.some(permissionRequired => configPerm[permissionRequired]));
            if (shouldDeepIn) {
                const resp = getFirstAccessibleRoute(route.routes, configPerm);
                if (resp !== null) {
                    return resp;
                }
            }
        }
        if (route.cannotRedirectTo) {
            continue;
        }
        if (route.authority === true || route.authority === undefined) {
            return route.path;
        }
        if (Array.isArray(route.authority)) {
            const matchingPermission = route.authority.find(permissionRequired => configPerm[permissionRequired]);
            if (matchingPermission) {
                if (route.routes) {
                    if (Array.isArray(route.routes)) {
                        const resp = getFirstAccessibleRoute(route.routes, configPerm);
                        if (resp !== null) {
                            return resp;
                        }
                    }
                }
                else {
                    return route.path;
                }
            }
        }
    }
    return null;
}
export function getRouteByPath(pathParam) {
    const path = pathParam.split("?")[0];
    let remainingRoutes = [...routes];
    while (remainingRoutes.length > 0) {
        const route = remainingRoutes.shift();
        if (route === undefined) {
            continue;
        }
        if (route.path === path) {
            return route;
        }
        if (Array.isArray(route.routes)) {
            remainingRoutes = remainingRoutes.concat(route.routes);
        }
    }
    return null; // this path was not found in the routes
}
export function hasAccessToRoute(path, configPerm) {
    const route = getRouteByPath(path);
    if (route === null) {
        return null;
    }
    if (route.authority === true || route.authority === undefined) {
        return true;
    }
    if (Array.isArray(route.authority)) {
        return route.authority.some(permissionRequired => configPerm[permissionRequired]);
    }
    return false;
}
